import { AritoIcon } from '@/components/custom/arito/icon';
import { NavMenu } from '../types';

export const congCuMenu: NavMenu = {
  title: 'Công cụ',
  items: [
    {
      title: 'Khai báo thông tin công cụ dụng cụ',
      icon: <AritoIcon icon={654} />,
      href: '/cong-cu/khai-bao-thong-tin-ccdc',
      group: 0
    },
    {
      title: 'Điều chỉnh giá trị CCDC',
      href: '/cong-cu/dieu-chinh-gia-tri-ccdc',
      group: 0
    },
    {
      title: 'Điều chuyển bộ phận sử dụng',
      href: '/cong-cu/dieu-chuyen-bo-phan-su-dung',
      group: 0
    },
    {
      title: 'Phân bổ công cụ dụng cụ',
      group: 0,
      items: [
        {
          title: 'Bút toán phân bổ CCDC',
          href: '/cong-cu/phan-bo-cong-cu-dung-cu/but-toan-phan-bo-ccdc',
          icon: <AritoIcon icon={572} />
        },
        {
          title: 'Khai báo hệ số phân bổ CCDC',
          href: '/cong-cu/phan-bo-cong-cu-dung-cu/khai-bao-he-so-phan-bo-ccdc'
        }
      ]
    },
    {
      title: 'Khai báo giảm/hỏng',
      href: '/cong-cu/khai-bao-giam-hong',
      group: 1
    },
    {
      title: 'Khai báo thôi phân bổ',
      href: '/cong-cu/khai-bao-thoi-phan-bo',
      group: 1
    },
    {
      title: 'Điều chỉnh phân bổ tháng',
      href: '/cong-cu/dieu-chinh-phan-bo-thang',
      group: 1
    },
    {
      title: 'Dừng phân bổ CCDC',
      group: 1,
      items: [
        {
          title: 'Khai báo thôi khấu hao CCDC',
          href: '/cong-cu/dung-phan-bo-ccdc/khai-bao-thoi-khau-hao-ccdc'
        }
      ]
    },
    {
      title: 'Kiểm kê CCDC',
      icon: <AritoIcon icon={727} />,
      group: 1,
      items: [
        {
          title: 'Danh sách CCDC',
          href: '/cong-cu/kiem-ke-ccdc/danh-sach-ccdc',
          icon: <AritoIcon icon={603} />
        },
        {
          title: 'Thẻ CCDC',
          href: '/cong-cu/kiem-ke-ccdc/the-ccdc',
          icon: <AritoIcon icon={819} />
        }
      ]
    },
    {
      title: 'Tăng/ giảm CCDC',
      icon: <AritoIcon icon={266} />,
      group: 1,
      items: [
        {
          title: 'Báo cáo chi tiết tăng/giảm CCDC',
          href: '/cong-cu/tang-giam-ccdc/bao-cao-chi-tiet-tang-giam-ccdc',
          icon: <AritoIcon icon={267} />
        }
      ]
    },
    {
      title: 'Bảng tính phân bổ CCDC',
      href: '/cong-cu/bang-tinh-phan-bo-ccdc',
      icon: <AritoIcon icon={269} />,
      group: 1
    },
    {
      title: 'Bảng hạch toán phân bổ CCDC',
      href: '/cong-cu/bang-hach-toan-phan-bo-ccdc',
      group: 1
    },
    {
      title: 'Bảng tính phân bổ CCDC theo tháng',
      href: '/cong-cu/bang-tinh-phan-bo-ccdc-theo-thang',
      group: 1
    }
  ]
};
